import "./index.css";

type PortfolioItem = {
  businessName: string;
  productType: string;
  description: string;
};

const portfolioItems: PortfolioItem[] = [
  {
    businessName: "Business Name Placeholder",
    productType: "Product Type Placeholder",
    description:
      "Briefly describe the finished product, the customization requested, and the result delivered for this customer.",
  },
  {
    businessName: "Business Name Placeholder",
    productType: "Product Type Placeholder",
    description:
      "Use this space for another previous work sample. This can call out materials, colors, event details, or any special production notes.",
  },
  {
    businessName: "Business Name Placeholder",
    productType: "Product Type Placeholder",
    description:
      "Add a short summary of what Hogcloud created and how it matched the customer's brand, occasion, or gift idea.",
  },
];

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      <section className="portfolio-intro">
        <p className="portfolio-kicker">Previous Work</p>
        <h1>Northwest Arkansas Technology and 3D Printing Portfolio</h1>
        <p>
          A collection of custom products, business gifts, and one-of-a-kind
          pieces created for past customers.
        </p>
      </section>

      <div className="portfolio-work-list" aria-label="Portfolio work samples">
        {portfolioItems.map((item, index) => (
          <section className="portfolio-work-section" key={`${item.businessName}-${index}`}>
            <div className="portfolio-work-meta">
              <span className="portfolio-section-number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p>{item.productType}</p>
            </div>

            <div className="portfolio-work-content">
              <h2>{item.businessName}</h2>
              <p>{item.description}</p>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
